import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ValidatedTextFieldNext } from 'components';
import theme from 'theme';

const styles = {
  textField: {
    fontSize: theme.spacing(4),
    fontWeight: 'bold',
  },
} as const;

const Title: FC = () => {
  const { t } = useTranslation();

  return (
    <ValidatedTextFieldNext
      fullWidth
      name="title"
      placeholder={t('leaderboard:titlePlaceholder')}
      InputProps={{ sx: styles.textField }}
    />
  );
};

export default Title;
